import { CHURCH } from '../config/church'
import type { ScreenId } from '../core/types'

/** Shared page furniture so every screen lines up on the same grid. */

export function pageHeader(eyebrow: string, title: string): HTMLElement {
  const header = document.createElement('header')
  header.className = 'page__header'

  const kicker = document.createElement('p')
  kicker.className = 'page__eyebrow'
  kicker.textContent = eyebrow

  const heading = document.createElement('h1')
  heading.className = 'page__title'
  heading.textContent = title

  header.append(kicker, heading)
  return header
}

/** Bottom-anchored return control. Every screen except the hub gets one. */
export function homeBar(go: (id: ScreenId) => void): HTMLElement {
  const bar = document.createElement('div')
  bar.className = 'home-bar'

  const button = document.createElement('button')
  button.type = 'button'
  button.className = 'home-bar__button'
  button.textContent = '처음으로'
  button.addEventListener('click', () => go('home'))

  const mark = document.createElement('p')
  mark.className = 'home-bar__mark'
  mark.textContent = CHURCH.nameKo

  bar.append(button, mark)
  return bar
}

export function icon(pathData: string, className = 'icon'): SVGElement {
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
  svg.setAttribute('viewBox', '0 0 24 24')
  svg.setAttribute('fill', 'none')
  svg.setAttribute('stroke', 'currentColor')
  svg.setAttribute('stroke-width', '1.6')
  svg.setAttribute('stroke-linecap', 'round')
  svg.setAttribute('stroke-linejoin', 'round')
  svg.setAttribute('aria-hidden', 'true')
  svg.setAttribute('class', className)

  const path = document.createElementNS('http://www.w3.org/2000/svg', 'path')
  path.setAttribute('d', pathData)
  svg.appendChild(path)
  return svg
}
